module.exports = __webpack_public_path__ + "media/images/writer/community/pc-headline-about-maker-2c12f98e1b055b6243d44f254daa94c3.png";